'use client';

import { SegmentPage } from '@flipster/features/src/misc/segment/segment-page';
import { SessionEvent } from '@flipster/utils/segment';

import { RegionBlocker } from '@web/hooks/useBlockedRegion';

import EmailSignUpPage from './EmailSignUpPage';

const Page = () => {
  return (
    <RegionBlocker>
      <SegmentPage name={SessionEvent.CreateAccountPageView} context={{ type: 'email' }} />
      <EmailSignUpPage />
    </RegionBlocker>
  );
};

export default Page;
